<script>

    export default {
        name: 'app',
        components: {
        },
        data () {
            return {
                headerCats: []
            };
        },
        computed: {
            mask () {
                return this.$store.state.maskShown.isShow;
            },
            maskZindex () {
                return this.$store.state.maskShown.zIndex;
            }
        },
        mounted () {
        },
        methods: {
        }
    };
</script>
<template>
    <div class="page-container">
        <div id="app" class="main-container">
            <router-view></router-view>
        </div>
        <transition name="fade">
            <div class="modal-mask" v-show="mask" style="z-index: 10000" :style="{zIndex: maskZindex}">

            </div>
        </transition>
    </div>
</template>
